/**
 * 漂流瓶常量定义
 */
export default class DriftBattleConst {

    //漂流瓶 选项类型
    static readonly DRIFT_BATTLE_TYPE_NOTHING : number = 0;//常规通知
    static readonly DRIFT_BATTLE_TYPE_COIN : number = 1;//金币
    static readonly DRIFT_BATTLE_TYPE_WECHAT : number = 2;//微信


}
